if ($('#reviews + #testimonials').length) {
    document.documentElement.style.setProperty('--vslSectionHeight',"".concat($('#reviews').outerHeight(), "px"));
}